import React from "react";

import { useSetRecoilState } from "recoil";
import { modalState } from "lib/store/common";

import { Modal } from "@atsent/components";

import { RequestCategoryTab } from "./RequestCategoryTab";
import { RequestList } from "./RequestList";

import "./RequestCategory.scss";

export type RequestCategoryProps = {
  cx?: string;
};

export const RequestCategory: React.FC<RequestCategoryProps> = ({
  cx = "",
}) => {
  const setModal = useSetRecoilState(modalState);
  return (
    <Modal
      list={[
        {
          title: "카테고리 추가 요청",
          component: <RequestCategoryTab />,
        },
        {
          title: "요청 목록",
          component: <RequestList />,
        },
      ]}
      cx={`RequestCategory ${cx}`}
      close={() => setModal((_) => ({ ..._, requestCategory: false }))}
    >
      aa
    </Modal>
  );
};
